import { RapButton, RapInput } from "@dynata/rex-raptor";
import React, { forwardRef, useCallback, useEffect } from "react";
import { toast } from "react-toastify";
import { ToastConfig } from "core/widgets/toastConfig.widget";
import useSendInvitationRequestEmail from "hooks/user/useSendInvitationRequestEmail";
import "scss/portalRequestInvitation.scss";

type Props = {
  context_id: string;
  setRequestAccountRequestSent: (value: boolean) => void;
  onClose: () => void;
};

const PortalRequestInvitation = forwardRef(
  (
    { context_id, onClose, setRequestAccountRequestSent }: Props,
    ref: React.ForwardedRef<HTMLDialogElement>,
  ) => {
    const {
      isSuccess,
      mutateAsync: sendInvitationRequestEmail,
      isError,
    } = useSendInvitationRequestEmail();

    const onSubmit = useCallback(
      async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const formData = Object.fromEntries(new FormData(e.currentTarget));

        const firstName = formData.name as string;
        const email = formData.email as string;

        if (!firstName || !email) {
          toast.error("Cannot leave required fields empty", ToastConfig);
          return;
        }

        await sendInvitationRequestEmail({
          contextId: context_id,
          email: formData.email as string,
          firstName: formData.name as string,
        });
      },
      [context_id, sendInvitationRequestEmail],
    );

    useEffect(() => {
      if (isSuccess) {
        setRequestAccountRequestSent(true);
        toast("successfully sent invitation request email", ToastConfig);
      } else if (isError) {
        toast.error("failed to send invitation request email", ToastConfig);
      }
      onClose();
    }, [isSuccess, isError]);

    return (
      <dialog ref={ref}>
        <form
          className="pri-container"
          onSubmit={onSubmit}
        >
          <h2>Request Invite</h2>
          <p>
            Please enter your email and we will contact the organization admin
            to add you to their team.
          </p>
          <div className="pri-input-container">
            <RapInput
              placeholder="Name"
              name="name"
              size="medium"
              inputSize="large"
            />
            <RapInput
              type="email"
              placeholder="Email"
              name="email"
              inputSize="large"
            />
          </div>
          <div className="pri-btn-container">
            <RapButton
              type="button"
              color="danger"
              styleType="secondary"
              size="small"
              onClick={onClose}
            >
              Cancel
            </RapButton>
            <RapButton
              type="submit"
              color="main"
            >
              Request Invite
            </RapButton>
          </div>
        </form>
      </dialog>
    );
  },
);

export default PortalRequestInvitation;
